import React, { useEffect, useState } from 'react';
import { useRoutes, useNavigate, useLocation } from 'react-router-dom';
import Devices from 'drivers/devices';
import TizenDebugOverlay from 'components/common/debug/TizenDebugOverlay';
import routes, { isPersistentLandingPath } from '../src/routes';
import Main from 'components/main/main';
import { AuthInterceptor } from 'utils/AuthInterceptor';
import Notification from 'components/common/notification/notification';
import StorageKeys from 'enum/storages.enum';
import Storages from 'storages';
import RemoteConfiguration from 'remoteConfiguration/remoteConfiguration';
import Route from 'enum/route.enum';
import { Landing } from 'enum/design';
import EventBus from 'utils/eventBus';
import { setNavigate } from 'components/common/navigation/redirect';
import { getIsLive, setIsLive } from 'utils/common/liveScreen';
import Services from 'services';
import getScreenShots from 'components/common/screenshots/getScreenShots';
import Wallpapers from 'components/common/wallpapers/wallpapers';
import { createGlobalStyle } from 'styled-components';
import CastingManager from 'castingManager/CastingManager';

const { route } = Route;
const pathsToIgnore = [route.DEVICEIPNOTFOUND, route.NOTFOUND, route.LOADING];

function App() {
  let subscriptions = {};
  const [isFirstTimeVisit, setIsFirstTimeVisit] = useState(false);
  const [landingMounted, setLandingMounted] = useState(false);
  Devices.getDevice(); // to initate the project in order to get the device type and store it in local storage
  const routing = useRoutes(routes());
  const navigate = useNavigate();


  useEffect(() => {
      CastingManager.initialize()
      return () => CastingManager.removeHdmiListener()
  }, [])
  const location = useLocation();
  const landingVisible = isPersistentLandingPath(location.pathname);

  useEffect(() => {
    if (landingVisible) {
      setLandingMounted(true);
    }
  }, [landingVisible]);

  const checkIsLive = () => {
    return new Promise((resolve) => {
      const isLive = getIsLive();
      if (isLive) {
        const device_id = Storages.MainStorage.getItem(StorageKeys.Keys.DEVICEREGDATA)['device_id'];
        const data = { device_id };
        Services.liveScreenService
          .deleteScreen(data)
          .then((result) => {
            resolve({ data: result ? true : false });
          })
          .catch((err) => {
            resolve({ data: false });
          });
      } else {
        resolve({ data: false });
      }
      setIsLive(true);
    });
  };
  function closeSocket() {
    checkIsLive().then((res) => {
      RemoteConfiguration.closeWebSocket();
    });
  }
  const setScreenToLive = () => {
    setIsLive(true);
    getScreenShots();
  };
  const subscribeForEvent = () => {
    subscriptions['getScreenShots'] = EventBus.subscribe('getScreenShots', () => {
      setScreenToLive();
    });

    subscriptions['showWelcomeScreen'] = EventBus.subscribe('showWelcomeScreen', () => {
      const activeTemplate = Storages.MainStorage.getItem(StorageKeys.Keys.ACTIVETEMPLATE);
      // Navigate to welcome screen for Warwick landing templates (check-in flow)
      if (activeTemplate === Landing.Warwick || activeTemplate === Landing.WarwickV1) {
        navigate(Route.route.WELCOME);
      }
    });
  };
  useEffect(() => {
    checkMouseHover();
    subscribeForEvent();
    if (!isFirstTimeVisit) {
      setNavigate(navigate);
      setIsFirstTimeVisit(true);
      if (pathsToIgnore.filter((path) => path === window.location.pathname).length === 0)
        navigate(Route.route.LOADING);
    }

    AuthInterceptor();
    window.addEventListener('beforeunload', closeSocket);
    window.addEventListener('unload', closeSocket);

    return () => {
      window.removeEventListener('beforeunload', closeSocket);
      for (const key in subscriptions) {
        if (Object.hasOwnProperty.call(subscriptions, key)) {
          subscriptions[key].unsubscribe();
        }
      }
    };
    // eslint-disable-next-line
  }, [isFirstTimeVisit]);
  function checkMouseHover() {
    document.onmousemove = () => {
      EventBus.publish('mouseMoved');
    };
  }

  const GlobalStyle = createGlobalStyle`
  html,body {
    overflow-x: hidden;
    overflow: hidden;
  }
`;

  return (
    <>
      {/* TODO: wallpapers component should not use carousal and should be here wrapping whole app*/}
      <GlobalStyle />
      <TizenDebugOverlay />
      <Wallpapers />
      {/* TODO: due to position absolute dom-to-image can not capture some elements,
      this is a stop gap solution to make content visible for screenshot */}
      {/* TODO: Remove the backgroudColor when done */}
      <div style={{ height: '100vh', width: '100vw', backgroundColor: 'rgba(39, 50, 71, 0.5)' }}>
        {/* Keep Landing mounted after first visit — hide instead of unmounting */}
        {landingMounted || landingVisible ? (
          <div
            style={{
              display: landingVisible ? 'block' : 'none',
              height: '100%',
              width: '100%',
            }}
          >
            <Main isActive={landingVisible} />
          </div>
        ) : null}
        <div
          style={{
            display: landingVisible ? 'none' : 'block',
            height: '100%',
            width: '100%',
          }}
        >
          {routing}
        </div>
      </div>
      <Notification></Notification>
    </>
  );
}

export default App;
